import { DataGridProvider, QueryParams } from '@/providers/DataGrid';
import { Paper } from '@/components/Paper';
import { UseQueryResult } from '@tanstack/react-query';


interface Props {
  query: (params: QueryParams) => UseQueryResult;
  children: React.ReactElement | React.ReactElement[];
  style?: any
}

export function DataGrid({ query, children, style }: Props) {
  return (
    <DataGridProvider query={query}>
      <Paper
        flex={1}
        padding={5}
        display={'flex'}
        flexDirection={'column'}
        {...style}
      >
        {children}
      </Paper>
    </DataGridProvider>
  );
}

export { ButtonAdd } from './ButtonAdd';
export { DeleteButton } from './DeleteButton';
export { Header } from './Header';
export { Pagination } from './Pagination';
export { SearchField } from './SearchField';
export { Table } from './Table';
export {TableNew} from './Table/indexNew'
